import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { LectionaryItemType } from './lectionary-item-type.service';
import { ReligionBranch } from '../components/religion-branch/religion-branch.component';
import { Localized } from '../../../objects';

@Injectable()
export class LectionaryItemNameService {

  constructor(private apiSvc: ApiService) { }

  public loadEntities(): Promise<LectionaryItemName[]> {

    const p = new Promise<LectionaryItemName[]>((resolve, reject) => {

      this.apiSvc.get("api/lectionaryitemname", null).subscribe(
        (data: LectionaryItemName[]) => {
          console.log("loadItemNames", data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p;
  }

  public loadSummaryEntities(): Promise<LectionaryItemNameSummary[]> {

    const p = new Promise<LectionaryItemNameSummary[]>((resolve, reject) => {

      this.apiSvc.get("api/lectionaryitemname/GetSummaryNames", null).subscribe(
        (data: LectionaryItemNameSummary[]) => {
          console.log("loadItemNames", data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p;
  }

  public loadSummaryEntitiesByLectionaryItemTypeId(itemTypeId: number): Promise<LectionaryItemNameSummary[]> {

    const p = new Promise<LectionaryItemNameSummary[]>((resolve, reject) => {

      this.apiSvc.get("api/lectionaryitemname/GetSummaryNamesByLectionaryItemType/" + itemTypeId, null).subscribe(
        (data: LectionaryItemNameSummary[]) => {
          console.log("loadSummaryEntitiesByLectionaryItemTypeId", data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p;
  }

public getItem(itemId: number): Promise<LectionaryItemName> {

  const p = new Promise<LectionaryItemName>((resolve, reject) => {

    this.apiSvc.get("api/lectionaryitemname/GetItem/" + itemId, null).subscribe(
      (data: LectionaryItemName) => {
        console.log("lectionaryitemname/GetItem", data);
        resolve(data);
      },
      (err) => {
        console.log("error", err);
      }
    );

  });

  return p;
}


public validate(passage: string): Promise<string> {

  const p = new Promise<string>((resolve, reject) => {

    var payload = {Passage: passage};
    this.apiSvc.post("api/lectionaryitemname/validate/", payload).subscribe(
      (data: string) => {
        console.log("lectionaryitemname/validate", data);
        resolve(data);
      },
      (err) => {
        console.log("error", err);
      }
    );

  });

  return p;
}

public delete(id: number): Promise<void> {

  const p = new Promise<void>((resolve, reject) => {

    var payload = new LectionaryItemName();
    payload.Id = id;

    this.apiSvc.post("api/lectionaryitemname/delete/", payload).subscribe(
      (data: string) => {
        console.log("lectionaryitemname/delete");
        resolve();
      },
      (err) => {
        console.log("error", err);
        reject(err);
      }
    );

  });

  return p;
}

}


export class LectionaryItemName {
  Id: number;
  Name: string;
  LectionaryItemType: LectionaryItemType;
  ReligionBranch: ReligionBranch;
  Localized: Localized[];
}


export class LectionaryItemNameSummary {
  Id: number;
  Name: string;
  LectionaryItemType: string;
  AvailableSearchTerms: string[];
}

